import { render, staticRenderFns } from "./StoreOpenInquireManagerList.vue?vue&type=template&id=752c56ba&scoped=true&"
import script from "./StoreOpenInquireManagerList.vue?vue&type=script&lang=js&"
export * from "./StoreOpenInquireManagerList.vue?vue&type=script&lang=js&"
import style0 from "./StoreOpenInquireManagerList.vue?vue&type=style&index=0&id=752c56ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752c56ba",
  null
  
)

export default component.exports